module.exports = __webpack_public_path__ + "static/media/topIcoList.9791b31a.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners/images/topIcoList.png
// module id = 1856
// module chunks = 146